import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateInventoryTab } from '../../../actions/productInventory';
import { ProductInventoryTabs } from '../productinventory.constants';
import styles from './Styles/product-tab.scss';
import Tabs from 'jd-library/Tabs';
import {useParams} from 'react-router-dom';

function ProductTabs(props) {
  const { allProducts, lowInventory, outofStock } = ProductInventoryTabs;
  const { currentTab } = props;
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [isScrolled, setScroll] = useState(
		typeof document === 'object' && (document.scrollingElement.scrollTop > 0)
	);
  const handleScroll = useCallback(() => {
		let isScrolled = document.scrollingElement.scrollTop > 0 ? true : false; 
		setScroll(isScrolled);
	}, []);
  const { tab } = useParams();
  const tabBase ={
    'low-inventory': 1,
    'out-of-stock': 2
  };
	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

  useEffect (()=>{
    console.log(tabBase[tab], 'tab key')
    setActiveTab(tabBase[tab])
    let tabName = tabBase[tab] ? inventoryTabs.tabs[tabBase[tab]]['tabKey'] : 'ALL_PRODUCTS'
    dispatch(updateInventoryTab(tabName));
  }, [])

  const inventoryTabs = {
    tabs: [
      {
        value: 'All Products',
        tabKey: allProducts,
      },
      {
        value: 'Low Inventory',
        tabKey: lowInventory,
      },
      {
        value: 'Out of Stock',
        tabKey: outofStock,
      }
    ],
    onTabChange: (index) => {
      setActiveTab(index)
      let tabName = inventoryTabs.tabs[index]['tabKey']
      dispatch(updateInventoryTab(tabName));
    },
  }

  return (
    <div className={`${styles['inventory-tab']} ${isScrolled ? 'prod-list-scrolled' : ''}`}>
      <Tabs
        data={inventoryTabs}
        activeTab={activeTab}
        variant={'bordertab'}
        tabClass={styles['pending-tabs']}
      />
    </div>
  )
}

export default memo(ProductTabs);